import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {CommonAutocompleteModule} from '../../../common-modules/common-autocomplete/common-autocomplete.module';
import {CommonCardModule} from '../../../common-modules/common-card/common-card.module';
import {
  NbAlertModule,
  NbButtonModule,
  NbDialogRef,
  NbIconModule,
  NbInputModule,
  NbOptionModule,
  NbSelectModule
} from '@nebular/theme';
import {NgxIntlTelInputModule} from 'ngx-intl-tel-input';
import {FormBuilder, FormGroup, ReactiveFormsModule} from '@angular/forms';
import {SharedModule} from '../../../shared/shared.module';
import {TranslateModule} from '@ngx-translate/core';
import {debounceTime, filter, takeUntil, takeWhile} from 'rxjs/operators';
import {lastValueFrom, Subject, timer} from 'rxjs';
import {AuthService} from '../../../shared/services/auth.service';
import {User} from '../../../shared/models/user';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'pv-verify-phone-email-dialog',
  imports: [
    CommonAutocompleteModule,
    CommonCardModule,
    NbButtonModule,
    NbIconModule,
    NbInputModule,
    NbOptionModule,
    NbSelectModule,
    NgxIntlTelInputModule,
    ReactiveFormsModule,
    SharedModule,
    TranslateModule,
    NbAlertModule,
    CommonModule
  ],
  templateUrl: './verify-phone-email-dialog.component.html',
  styleUrl: './verify-phone-email-dialog.component.scss'
})
export class VerifyPhoneEmailDialogComponent implements OnInit, OnDestroy {

  private destroy$: Subject<void> = new Subject<void>();

  public form: FormGroup;
  public phoneStatus: 'danger' | 'info' | 'success' = 'info';
  public emailStatus: 'info' | 'success' = 'info';
  public showResendOtp = false;

  @Input() user: User;
  @Output() submitEvent = new EventEmitter();

  constructor(protected dialogRef: NbDialogRef<VerifyPhoneEmailDialogComponent>,
              private fb: FormBuilder,
              private authService: AuthService) {
  }

  ngOnInit() {
    this.form = this.fb.group({
      otp: [null]
    });

    this.form.get('otp').valueChanges.pipe(
      takeUntil(this.destroy$),
      filter(value => value.length === 6),
      debounceTime(1000)
    ).subscribe(value => {
      this.phoneStatus = 'info';
      this.form.get('otp').disable({emitEvent: false});
      lastValueFrom(this.authService.verifyPhoneOtp(value)).then(() => {
        this.phoneStatus = 'success';
      }).catch(error => {
        this.phoneStatus = 'danger';
        this.form.get('otp').enable({emitEvent: false});
      });
    });

    if (this.user.pendingPhone) {
      this.startResendOtpTimer();
    }

    if (this.user.pendingEmail) {
      timer(0, 5000).pipe(
        takeUntil(this.destroy$),
        takeWhile(() => this.emailStatus !== 'success')
      ).subscribe(() => {
        lastValueFrom(this.authService.getUserPendingEmail()).then(res => {
          if (this.emailStatus === 'info' && !res.data.pendingEmail) {
            this.emailStatus = 'success';
          }
        });
      });
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private startResendOtpTimer() {
    this.showResendOtp = false;
    timer(60000).pipe(
      takeUntil(this.destroy$),
      takeWhile(() => this.phoneStatus !== 'success')
    ).subscribe(() => {
      this.showResendOtp = true;
    });
  }

  public resendOtp() {
    lastValueFrom(this.authService.resendPhoneOtp()).finally(() => {
      this.startResendOtpTimer();
    });
  }

  public submit() {
    this.submitEvent.emit();
  }

}
